export default __webpack_public_path__ + "static/media/ic_gmx_avax.500db2fa.svg";